/*  ==========================================================================
    TEXT
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initText($element) {

    // show the entire text on mobile devices if text was collapsed
    $element.find('.bn-text__collapsible-trigger').on('click', function(){
        $(this).remove();
        $element.removeClass('bn-text--collapsible');
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/text.js